import { Divider, Stack, styled, Typography } from '@mui/material';

import { IcBookmark } from '@/assets/images';
import { ICFS } from '@/models';
import { CFSAssignmentStatusItem } from '@/pages/CFS/Edit/components/CFSAssignmentStatusItem';
import { getAddressInfoLocation } from '@/services';

export const CFSListItem = ({
  cfs,
  isQueued = false,
}: {
  cfs: ICFS;
  isQueued?: boolean;
}) => {
  const StyledStack = styled(Stack)(() => ({
    '& .cfs-assignment-status': {
      marginLeft: '10px',
      height: '43px',
      '& .MuiChip-label': {
        lineHeight: '17px',
        padding: '0px 8px',
      },
    },
  }));

  return (
    <Stack
      flex={1}
      padding={2}
      border={1}
      borderColor="divider"
      borderRadius={2}
      gap={2}
      sx={{
        position: 'relative',
      }}
    >
      <StyledStack direction="row" alignItems="center" paddingTop={1}>
        <Typography fontWeight={600} fontSize={21} align="left">
          {cfs.shortDescription || 'No Emergency detail for this CFS'}
        </Typography>
        <CFSAssignmentStatusItem
          assignmentStatus={cfs.assignmentStatus}
          isReadyToDispatch={cfs.isReadyToDispatch}
          className="cfs-assignment-status"
        />
        {isQueued && (
          <IcBookmark
            width={18}
            height={22}
            style={{
              marginLeft: 'auto',
            }}
          />
        )}
      </StyledStack>
      <Divider />
      <Stack>
        <Typography fontWeight={500} fontSize={18} align="left">
          {getAddressInfoLocation(cfs?.addressInfo) ||
            'No address provided for this CFS'}
        </Typography>
        <Typography fontSize={18} fontWeight={400}>
          {cfs?.addressInfo?.additionalInfo?.beat?.name}
        </Typography>
      </Stack>
    </Stack>
  );
};
